module.exports = __webpack_public_path__ + "static/media/HelveticaNeueCyr-Bold.4594f11d.woff2";